import { render, staticRenderFns } from "./FlightDetailsInfo.vue?vue&type=template&id=9573126c&scoped=true&"
import script from "./FlightDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./FlightDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./FlightDetailsInfo.vue?vue&type=style&index=0&id=9573126c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9573126c",
  null
  
)

export default component.exports